import {reactive} from "vue";

const pad = number => String(number).padStart(2, '0');
/** Jour local au format AAAA-MM-JJ (jamais via toISOString, qui décale d'un jour selon le fuseau) */
const toDay = date => `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;

export const GRANULARITIES = [
    {value: 'month', label: 'Mois'},
    {value: 'quarter', label: 'Trimestre'},
    {value: 'year', label: 'Année'},
];

/** Chiffre d'affaires affiché par les graphiques qui le proposent */
export const METRICS = [
    {value: 'invoiced', label: 'Facturé'},
    {value: 'collected', label: 'Encaissé'},
];

export const PERIOD_PRESETS = [
    {key: 'last12', label: '12 derniers mois', granularity: 'month', range: now => [new Date(now.getFullYear(), now.getMonth() - 11, 1), now]},
    {key: 'currentYear', label: 'Année en cours', granularity: 'month', range: now => [new Date(now.getFullYear(), 0, 1), new Date(now.getFullYear(), 11, 31)]},
    {key: 'previousYear', label: 'Année précédente', granularity: 'month', range: now => [new Date(now.getFullYear() - 1, 0, 1), new Date(now.getFullYear() - 1, 11, 31)]},
    {key: 'last3Years', label: '3 dernières années', granularity: 'quarter', range: now => [new Date(now.getFullYear() - 2, 0, 1), new Date(now.getFullYear(), 11, 31)]},
];

/**
 * Période, découpage et chiffre d'affaires affichés par tous les sous-onglets des statistiques.
 * L'état est conservé en mémoire : changer de sous-onglet ne change pas la période.
 */
export class StatisticsService {
    static data = reactive({
        start: undefined,
        end: undefined,
        granularity: 'month',
        metric: 'invoiced',
        preset: undefined,
    });

    static init() {
        if (!StatisticsService.data.start) StatisticsService.applyPreset('last12');
    }

    static applyPreset(key) {
        const preset = PERIOD_PRESETS.find(candidate => candidate.key === key);
        const [start, end] = preset.range(new Date());
        StatisticsService.data.start = toDay(start);
        StatisticsService.data.end = toDay(end);
        StatisticsService.data.granularity = preset.granularity;
        StatisticsService.data.preset = key;
    }

    /** Une date saisie à la main sort des périodes prédéfinies */
    static setDates(start, end) {
        StatisticsService.data.start = start;
        StatisticsService.data.end = end;
        StatisticsService.data.preset = undefined;
    }

    static isPeriodValid() {
        const {start, end} = StatisticsService.data;
        return !!start && !!end && start <= end;
    }

    /** Paramètres d'URL de la période (vide si elle est incomplète ou incohérente) */
    static urlParams() {
        const {start, end, granularity} = StatisticsService.data;
        return StatisticsService.isPeriodValid() ? `?start=${start}&end=${end}&granularity=${granularity}` : '';
    }
}
